import moment from 'moment'

export function mostRecentlyUpdated(allConfigs, ...keys) {
  let result = null

  for (let key of keys) {
    const row = allConfigs.find((x) => x.key == key)
    if (row != null) {
      if (result == null || moment(row.updatedAt).isAfter(result.updatedAt)) {
        result = row
      }
    }
  }
  return result
}

export function decHex(x, def) {
  if (x == null) return def
  return `${x} (0x${x.toString(16)})`
}

export function getCfg(allConfigs, key) {
  let row = allConfigs.find((x) => x.key == key)
  return row && row.value
}

export function getManyCfgs(allConfigs, ...keys) {
  let result = {}
  for (let x of keys) result[x] = getCfg(allConfigs, x)
  return result
}
